import React from 'react';

import { CloudProviders } from '@ariksa/cloud-account';
import { NativeResources, Resources } from '@ariksa/inventory-core/api';

import { APIGatewayRestAPIMetadata } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/ResourceMetadata/Summary/App/APIGateway/APIGatewayRestAPIMetadata';
import { ElastiCacheMetadata } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/ResourceMetadata/Summary/App/ElastiCache/ElastiCacheMetadata';
import { ElasticMapReduceMetadata } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/ResourceMetadata/Summary/App/ElasticMapReduce/ElasticMapReduceMetadata';
import { ElasticSearchDomain } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/ResourceMetadata/Summary/App/ElasticSearch/ElasticSearchDomain';
import { SagemakerMetadata } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/ResourceMetadata/Summary/App/Sagemaker/SagemakerMetadata';
import { SNSTopicMetadata } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/ResourceMetadata/Summary/App/SNS/SNSTopicMetadata';
import { SQSMetadata } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/ResourceMetadata/Summary/App/SQS/SQSMetadata';
import { WafClassicMetadata } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/ResourceMetadata/Summary/App/WAF/WafClassicMetadata';
import { WafV2Metadata } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/ResourceMetadata/Summary/App/WAF/WafV2Metadata';
import { ECSClusterMetadata } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/ResourceMetadata/Summary/Cluster/ECSCluster/ECSClusterMetadata';
import { KubernetesMetadata } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/ResourceMetadata/Summary/Cluster/EKS/KubernetesMetadata';
import { NeptuneClusterMetadata } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/ResourceMetadata/Summary/Cluster/NeptuneCluster/NeptuneClusterMetadata';
import { RDSClusterMetadata } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/ResourceMetadata/Summary/Cluster/RdsCluster/RDSClusterMetadata';
import { RedshiftClusterMetadata } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/ResourceMetadata/Summary/Cluster/RedshiftCluster/RedshiftClusterMetadata';
import { GitlabRepositoryMetadata } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/ResourceMetadata/Summary/Code/GitLabRepository/GitlabRepositoryMetadata';
import { AutoScalingGroupMetadata } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/ResourceMetadata/Summary/Compute/AutoScalingGroup/AutoScalingGroupMetadata';
import { ContainerMetadata } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/ResourceMetadata/Summary/Compute/Container/ContainerMetadata';
import { ECSContainerInstanceMetadata } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/ResourceMetadata/Summary/Compute/ECS/ECSContainerInstance';
import { ECSMetadata } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/ResourceMetadata/Summary/Compute/ECS/ECSMetadata';
import { ECSServiceMetadata } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/ResourceMetadata/Summary/Compute/ECS/ECSServiceMetadata';
import { LambdaMetadata } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/ResourceMetadata/Summary/Compute/Lambda/LambdaMetadata';
import { VMMetadata } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/ResourceMetadata/Summary/Compute/VirtualMachine/VMMetadata';
import { AccessKeyMetadata } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/ResourceMetadata/Summary/Credential/AccessKey/AccessKeyMetadata';
import { AcmCertificateMetadata } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/ResourceMetadata/Summary/Credential/Certificate/AcmCertificateMetadata';
import { RdsCertificateMetadata } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/ResourceMetadata/Summary/Credential/Certificate/RdsCertificateMetadata';
import { KeyPairMetadata } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/ResourceMetadata/Summary/Credential/KeyPair/KeyPairMetadata';
import { KMSMetadata } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/ResourceMetadata/Summary/Credential/KMS/KMSMetadata';
import { SecretMetadata } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/ResourceMetadata/Summary/Credential/Secret/SecretMetadata';
import { DocumentDBMetadata } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/ResourceMetadata/Summary/Data/DocumentDB/DocumentDBMetadata';
import { DynamoDBMetadata } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/ResourceMetadata/Summary/Data/DynamoDB/DynamoDBMetadata';
import { EBSMetadata } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/ResourceMetadata/Summary/Data/EBS/EBSMetadata';
import { EFSMetadata } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/ResourceMetadata/Summary/Data/EFS/EFSMetadata';
import { NeptuneInstanceMetadata } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/ResourceMetadata/Summary/Data/Neptune/NeptuneInstanceMetadata';
import { ObjectStorageMetadata } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/ResourceMetadata/Summary/Data/ObjectStorage';
import { RDSInstanceMetadata } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/ResourceMetadata/Summary/Data/RDS/RDSInstanceMetadata';
import { SnowflakeDatabaseMetadata } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/ResourceMetadata/Summary/Data/Snowflake/SnowflakeDatabaseMetadata';
import { SnowflakeTableMetadata } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/ResourceMetadata/Summary/Data/Snowflake/SnowflakeTableMetadata';
import { DynamicMetadata } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/ResourceMetadata/Summary/DynamicMetadata';
import { ElasticContainerRegistryMetadata } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/ResourceMetadata/Summary/ECR/ElasticContainerRegistryMetadata';
import { ElasticBeanstalkMetadata } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/ResourceMetadata/Summary/ElasticBeanstalk/ElasticBeanstalkMetadata';
import { AccountMetadata } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/ResourceMetadata/Summary/Identity/AccountRoot/AccountMetadata';
import { AzureADGroupMetadata } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/ResourceMetadata/Summary/Identity/AzureADGroup/AzureADGroupMetadata';
import { AzureADUserMetadata } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/ResourceMetadata/Summary/Identity/AzureADUser/AzureADUserMetadata';
import { IAMGroupMetadata } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/ResourceMetadata/Summary/Identity/IAMGroup/IAMGroupMetadata';
import { IAMRoleMetadata } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/ResourceMetadata/Summary/Identity/IAMRole/IAMRoleMetadata';
import { IAMUserMetadata } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/ResourceMetadata/Summary/Identity/IAMUser/IAMUserMetadata';
import { OktaDomainMetadata } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/ResourceMetadata/Summary/Identity/OktaDomain/OktaDomainMetadata';
import { OktaGroupMetadata } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/ResourceMetadata/Summary/Identity/OktaGroup/OktaGroupMetadata';
import { OktaUserMetadata } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/ResourceMetadata/Summary/Identity/OktaUser/OktaUserMetadata';
import { SnowflakeRoleMetadata } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/ResourceMetadata/Summary/Identity/SnowflakeRole/SnowflakeRoleMetadata';
import { SnowflakeUserMetadata } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/ResourceMetadata/Summary/Identity/SnowflakeUser/SnowflakeUserMetadata';
import { CloudTrailMetadata } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/ResourceMetadata/Summary/Logging/CloudTrail/CloudTrailMetadata';
import { CloudFrontMetadata } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/ResourceMetadata/Summary/Network/CloudFront/CloudFrontMetadata';
import { DHCPMetadata } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/ResourceMetadata/Summary/Network/DHCP/DHCPMetadata';
import { ElasticLoadBalancerMetadata } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/ResourceMetadata/Summary/Network/ElasticLoadBalancer/ElasticLoadBalancerMetadata';
import { InternetGatewayMetadata } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/ResourceMetadata/Summary/Network/InternetGateway/InternetGatewayMetadata';
import { NATGatewayMetadata } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/ResourceMetadata/Summary/Network/NATGateway/NATGatewayMetadata';
import { NetworkACLMetadata } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/ResourceMetadata/Summary/Network/NetworkACL/NetworkACLMetadata';
import { NetworkInterfaceMetadata } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/ResourceMetadata/Summary/Network/NetworkInterface/NetworkInterfaceMetadata';
import { PrefixListMetadata } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/ResourceMetadata/Summary/Network/PrefixList/PrefixListMetadata';
import { Route53HealthCheckMetadata } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/ResourceMetadata/Summary/Network/Route53/Route53HealthCheckMetadata';
import { Route53HostedZoneMetadata } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/ResourceMetadata/Summary/Network/Route53/Route53HostedZoneMetadata';
import { RouteTableMetadata } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/ResourceMetadata/Summary/Network/RouteTable/RouteTableMetadata';
import { SecurityGroupOverview } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/ResourceMetadata/Summary/Network/SecurityGroup/SecurityGroupOverview';
import { SubnetMetadata } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/ResourceMetadata/Summary/Network/Subnet/SubnetMetadata';
import { TransitGatewayMetadata } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/ResourceMetadata/Summary/Network/TransitGateway/TransitGatewayMetadata';
import { TransitGatewayAttachmentMetadata } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/ResourceMetadata/Summary/Network/TransitGatewayAttachment/TransitGatewayAttachmentMetadata';
import { VirtualInterfaceMetadata } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/ResourceMetadata/Summary/Network/VirtualInterface/VirtualInterfaceMetadata';
import { VPCMetadata } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/ResourceMetadata/Summary/Network/VPC/VPCMetadata';
import { ConfigurationMetadata } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/ResourceMetadata/Summary/Organization/ConfigurationMetadata';
import { OktaOrganizationMetadata } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/ResourceMetadata/Summary/Organization/OktaOrganizationMetadata';
import { OrganizationMetadata } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/ResourceMetadata/Summary/Organization/OrganizationMetadata';
import { OrgUnitMetadata } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/ResourceMetadata/Summary/Organization/OrgUnitMetadata';
import { IAMPolicyMetadata } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/ResourceMetadata/Summary/Policy/IAMPolicyMetadata';
import { IdentityPolicyMetadata } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/ResourceMetadata/Summary/Policy/IdentityPolicyMetadata';
import { ResourcePolicyMetadata } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/ResourceMetadata/Summary/Policy/ResourcePolicyMetadata';
import { EbsSnapshotMetadata } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/ResourceMetadata/Summary/Snapshot/EbsSnapshotMetadata';
import { RdsSnapshotMetadata } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/ResourceMetadata/Summary/Snapshot/RdsSnapshotMetadata';
import { usesDynamicSummary } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/ResourceMetadata/Summary/utils';

import { ResourceOverview } from '../ResourceOverview';

import { AWSBedrockAgentMetadata } from './AI&ML/AWSBedrockAgent/AWSBedrockAgentMetadata';
import { AWSBedrockAgentCoreBrowserMetadata } from './AI&ML/AWSBedrockAgentCoreBrowser/AWSBedrockAgentCoreBrowserMetadata';
import { AWSBedrockAgentCoreCodeInterpreterMetadata } from './AI&ML/AWSBedrockAgentCoreCodeInterpreter/AWSBedrockAgentCoreCodeInterpreterMetadata';
import { AWSBedrockAgentCoreGatewayMetadata } from './AI&ML/AWSBedrockAgentCoreGateway/AWSBedrockAgentCoreGatewayMetadata';
import { AWSBedrockAgentCoreMemoryMetadata } from './AI&ML/AWSBedrockAgentCoreMemory/AWSBedrockAgentCoreMemoryMetadata';
import { AWSBedrockAgentCorePolicyMetadata } from './AI&ML/AWSBedrockAgentCorePolicy/AWSBedrockAgentCorePolicyMetadata';
import { AWSBedrockAgentCorePolicyEngineMetadata } from './AI&ML/AWSBedrockAgentCorePolicyEngine/AWSBedrockAgentCorePolicyEngineMetadata';
import { AWSBedrockAgentCoreRuntimeMetadata } from './AI&ML/AWSBedrockAgentCoreRuntime/AWSBedrockAgentCoreRuntimeMetadata';
import { AWSBedrockCustomModelMetadata } from './AI&ML/AWSBedrockCustomModel/AWSBedrockCustomModelMetadata';
import { AWSBedrockFlowMetadata } from './AI&ML/AWSBedrockFlow/AWSBedrockFlowMetadata';
import { AWSBedrockFoundationModelMetadata } from './AI&ML/AWSBedrockFoundationModel/AWSBedrockFoundationModelMetadata';
import { AWSBedrockGuardrailMetadata } from './AI&ML/AWSBedrockGuardrail/AWSBedrockGuardrailMetadata';
import { AWSBedrockImportedModelMetadata } from './AI&ML/AWSBedrockImportedModel/AWSBedrockImportedModelMetadata';
import { AWSBedrockInferenceProfileMetadata } from './AI&ML/AWSBedrockInferenceProfile/AWSBedrockInferenceProfileMetadata';
import { AWSBedrockInvocationLoggingMetadata } from './AI&ML/AWSBedrockInvocationLogging/AWSBedrockInvocationLoggingMetadata';
import { AWSBedrockKnowledgeBaseMetadata } from './AI&ML/AWSBedrockKnowledgeBase/AWSBedrockKnowledgeBaseMetadata';
import { AWSBedrockKnowledgeBaseDataSourceMetadata } from './AI&ML/AWSBedrockKnowledgeBaseDataSource/AWSBedrockKnowledgeBaseDataSourceMetadata';
import { AWSBedrockPromptMetadata } from './AI&ML/AWSBedrockPrompt/AWSBedrockPromptMetadata';
import { AWSBedrockProvisionedModelMetadata } from './AI&ML/AWSBedrockProvisionedModel/AWSBedrockProvisionedModelMetadata';
import { AWSGlueDatabaseMetadata } from './Data/AWSGlueDatabase/AWSGlueDatabaseMetadata';
import { AWSGlueDataCatalogMetadata } from './Data/AWSGlueDataCatalog/AWSGlueDataCatalogMetadata';
import { AWSGlueTableMetadata } from './Data/AWSGlueTable/AWSGlueTableMetadata';
import { S3TableBucketMetadata } from './Data/S3TableBucket/S3TableBucketMetadata';
import { S3VectorBucketMetadata } from './Data/S3VectorBucket/S3VectorBucketMetadata';

export const getSummary = (resource_type: string, provider: CloudProviders) => {
  if (usesDynamicSummary(resource_type, provider)) return <DynamicMetadata />;
  switch (resource_type) {
    case NativeResources.AsgResourcePolicy:
    case NativeResources.OrganizationPolicy:
    case NativeResources.ResourcePolicy:
      return <ResourcePolicyMetadata />;
    case NativeResources.AccountPasswordIdentityPolicy:
      return <IdentityPolicyMetadata />;
    case NativeResources.IamPolicy:
      return <IAMPolicyMetadata />;
    case Resources.Role:
    case NativeResources.IamRole:
      return <IAMRoleMetadata />;
    case NativeResources.NetworkAcl:
      return <NetworkACLMetadata />;
    case Resources.User:
    case NativeResources.IamUser:
      return <IAMUserMetadata />;
    case NativeResources.ElasticFileSystem:
      return <EFSMetadata />;
    case Resources.BlockStorage:
    case NativeResources.ElasticBlockStorage:
      return <EBSMetadata />;
    case NativeResources.KeyManagementService:
      return <KMSMetadata />;
    case NativeResources.RelationalDatabaseService:
      return <RDSInstanceMetadata />;
    case NativeResources.IamUserAccessKey:
      return <AccessKeyMetadata />;
    case NativeResources.RdsCluster:
      return <RDSClusterMetadata />;
    case NativeResources.LambdaFunction:
      return <LambdaMetadata />;
    case NativeResources.DynamoDb:
      return <DynamoDBMetadata />;
    case Resources.Notification:
    case NativeResources.SimpleNotificationService:
      return <SNSTopicMetadata />;
    case NativeResources.AwsOrganization:
      return <OrganizationMetadata />;
    case NativeResources.OrganizationUnit:
      return <OrgUnitMetadata />;
    case NativeResources.SimpleQueueService:
      return <SQSMetadata />;
    case NativeResources.Subnet:
      return <SubnetMetadata />;
    case NativeResources.SecurityGroup:
      return <SecurityGroupOverview />;
    case NativeResources.VirtualPrivateCloud:
      return <VPCMetadata />;
    case NativeResources.VirtualInterface:
      return <VirtualInterfaceMetadata />;
    case NativeResources.AwsConfigRule:
      return <ConfigurationMetadata />;
    case NativeResources.SimpleStorageService:
    case Resources.ObjectStorage:
      return <ObjectStorageMetadata />;
    case NativeResources.ElasticKubernetesService:
      return <KubernetesMetadata />;
    case Resources.VirtualMachine:
    case NativeResources.Ec2Instance:
      return <VMMetadata />;
    case NativeResources.ElasticSearch:
      return <ElasticSearchDomain />;
    case NativeResources.RedshiftCluster:
      return <RedshiftClusterMetadata />;
    case NativeResources.ElasticContainerService:
      return <ECSMetadata />;
    case NativeResources.EcsCluster:
      return <ECSClusterMetadata />;
    case NativeResources.ElasticContainerRegistry:
      return <ElasticContainerRegistryMetadata />;
    case NativeResources.EcsContainerInstance:
      return <ECSContainerInstanceMetadata />;
    case NativeResources.EcsService:
      return <ECSServiceMetadata />;
    case NativeResources.EbsSnapshot:
      return <EbsSnapshotMetadata />;
    case NativeResources.Secret:
      return <SecretMetadata />;
    case NativeResources.AcmCertificate:
      return <AcmCertificateMetadata />;
    case NativeResources.RdsCertificate:
      return <RdsCertificateMetadata />;
    case NativeResources.CloudFront:
      return <CloudFrontMetadata />;
    case NativeResources.Wafv1:
      return <WafClassicMetadata />;
    case NativeResources.Wafv2:
      return <WafV2Metadata />;
    case NativeResources.ElasticBeanstalk:
      return <ElasticBeanstalkMetadata />;
    case NativeResources.InternetGateway:
      return <InternetGatewayMetadata />;
    case NativeResources.NatGateway:
      return <NATGatewayMetadata />;
    case NativeResources.TransitGateway:
      return <TransitGatewayMetadata />;
    case NativeResources.TransitGatewayAttachment:
      return <TransitGatewayAttachmentMetadata />;
    case NativeResources.SubnetRouteTable:
    case NativeResources.TransitGatewayRouteTable:
      return <RouteTableMetadata />;
    case NativeResources.SagemakerNotebookInstances:
      return <SagemakerMetadata />;
    case NativeResources.OktaUser:
      return <OktaUserMetadata />;
    case NativeResources.OktaGroup:
      return <OktaGroupMetadata />;
    case NativeResources.OktaDomain:
      return <OktaDomainMetadata />;
    case NativeResources.OktaOrganization:
      return <OktaOrganizationMetadata />;
    case NativeResources.AzureAdUser:
      return <AzureADUserMetadata />;
    case NativeResources.AzureAdGroup:
      return <AzureADGroupMetadata />;
    case NativeResources.AutoscalingGroup:
    case NativeResources.Ec2AutoScalingGroup:
      return <AutoScalingGroupMetadata />;
    case NativeResources.Route53HostedZone:
      return <Route53HostedZoneMetadata />;
    case NativeResources.Route53HealthCheck:
      return <Route53HealthCheckMetadata />;
    case NativeResources.RdsSnapshot:
      return <RdsSnapshotMetadata />;
    case NativeResources.ElasticLoadBalancer:
    case NativeResources.ElasticLoadBalancerv2:
      return <ElasticLoadBalancerMetadata />;
    case NativeResources.ElasticMapReduce:
      return <ElasticMapReduceMetadata />;
    case NativeResources.ApiGatewayRestApi:
      return <APIGatewayRestAPIMetadata />;
    case NativeResources.IamGroup:
      return <IAMGroupMetadata />;
    case NativeResources.ElastiCache:
      return <ElastiCacheMetadata />;
    case NativeResources.DocumentDb:
      return <DocumentDBMetadata />;
    case NativeResources.NeptuneCluster:
      return <NeptuneClusterMetadata />;
    case NativeResources.Neptune:
      return <NeptuneInstanceMetadata />;
    case NativeResources.ElasticNetworkInterface:
      return <NetworkInterfaceMetadata />;
    case NativeResources.CloudTrail:
      return <CloudTrailMetadata />;
    case NativeResources.PrefixList:
      return <PrefixListMetadata />;
    case NativeResources.DhcpOptions:
      return <DHCPMetadata />;
    case NativeResources.SshKeyPair:
      return <KeyPairMetadata />;
    case NativeResources.AwsAccount:
    case NativeResources.AccountRoot:
      return <AccountMetadata />;
    case NativeResources.SnowflakeUsers:
      return <SnowflakeUserMetadata />;
    case NativeResources.SnowflakeRoles:
      return <SnowflakeRoleMetadata />;
    case NativeResources.SnowflakeDatabases:
      return <SnowflakeDatabaseMetadata />;
    case NativeResources.SnowflakeTables:
      return <SnowflakeTableMetadata />;
    case NativeResources.Container:
      return <ContainerMetadata />;
    case NativeResources.BitBucketRepository:
      return <GitlabRepositoryMetadata />;
    case NativeResources.S3TableBucket:
      return <S3TableBucketMetadata />;
    case NativeResources.S3VectorBucket:
      return <S3VectorBucketMetadata />;
    case 'AWSGlueDataCatalog':
      return <AWSGlueDataCatalogMetadata />;
    case 'AWSGlueDatabase':
    case 'AWSGlueDataCatalogDatabase':
      return <AWSGlueDatabaseMetadata />;
    case 'AWSGlueTable':
    case 'AWSGlueDataCatalogTable':
      return <AWSGlueTableMetadata />;
    case 'AWSBedrockAgent':
      return <AWSBedrockAgentMetadata />;
    case 'AWSBedrockAgentCoreBrowser':
      return <AWSBedrockAgentCoreBrowserMetadata />;
    case 'AWSBedrockAgentCoreCodeInterpreter':
      return <AWSBedrockAgentCoreCodeInterpreterMetadata />;
    case 'AWSBedrockAgentCoreGateway':
      return <AWSBedrockAgentCoreGatewayMetadata />;
    case 'AWSBedrockAgentCoreMemory':
      return <AWSBedrockAgentCoreMemoryMetadata />;
    case 'AWSBedrockAgentCorePolicy':
      return <AWSBedrockAgentCorePolicyMetadata />;
    case 'AWSBedrockAgentCorePolicyEngine':
      return <AWSBedrockAgentCorePolicyEngineMetadata />;
    case 'AWSBedrockAgentCoreRuntime':
      return <AWSBedrockAgentCoreRuntimeMetadata />;
    case NativeResources.AwsBedrockCustomModel:
      return <AWSBedrockCustomModelMetadata />;
    case 'AWSBedrockFlow':
      return <AWSBedrockFlowMetadata />;
    case NativeResources.AwsBedrockFoundationModel:
      return <AWSBedrockFoundationModelMetadata />;
    case 'AWSBedrockGuardrail':
      return <AWSBedrockGuardrailMetadata />;
    case 'AWSBedrockInferenceProfile':
      return <AWSBedrockInferenceProfileMetadata />;
    case NativeResources.AwsBedrockImportedModel:
      return <AWSBedrockImportedModelMetadata />;
    case 'AWSBedrockInvocationLogging':
      return <AWSBedrockInvocationLoggingMetadata />;
    case 'AWSBedrockKnowledgeBase':
      return <AWSBedrockKnowledgeBaseMetadata />;
    case 'AWSBedrockDataSource':
      return <AWSBedrockKnowledgeBaseDataSourceMetadata />;
    case 'AWSBedrockPrompt':
      return <AWSBedrockPromptMetadata />;
    case NativeResources.AwsBedrockProvisionedModel:
    case 'AWSBedrockProvisionedDeployment':
      return <AWSBedrockProvisionedModelMetadata />;
    default:
      return <ResourceOverview />;
  }
};
